import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import {default as Reactsel} from 'react-select';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import PaginationComponent from '../PaginationComponent';

class AdminViewCourseEntities extends Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        purchaseItemType: [],
        purchaseEntity: [],
        purchaseItemCriteria: 1,
        purchaseEntityCriteria: 1,
        purchaseItem: [],
      },
      totalCount: '',
      itemsPerPage: 10,
    }
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    return api.getPurchaseEntities(this.props.user.accessToken)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseEntity = result.data
        }
        return api.getPurchaseItemType(this.props.user.accessToken)
      }).then((result) =>{
        if(result.status === 'success'){
          data.purchaseItemType= result.data
        }
        this.setState({data: data})
      })
  }

  handleFetchCons = (pageNo) => {
    this.handleSearchQuery(pageNo)
  }

  handlePurchaseItemType = (e) => {

    let data = Object.assign({}, this.state.data)
    data.purchaseItemCriteria = e.target.value
    this.setState({data: data})
  }

  handlePurchaseEntity = (e) => {

    let data = Object.assign({}, this.state.data)
    data.purchaseEntityCriteria = e.target.value
    this.setState({data: data})
  }

  handleSearchQuery = (pageNo) => {
    let data = Object.assign({}, this.state.data)
    let totalCount;
    api.getPurchaseItemToView(this.props.user.accessToken, this.state.data.purchaseEntityCriteria, this.state.data.purchaseItemCriteria, pageNo, this.state.itemsPerPage)
      .then((result) => {
        if(result.status === 'success') {
          data.purchaseItem = result.data
          totalCount= result.count
        }
        this.setState({data: data, totalCount: totalCount, pageNo: pageNo})
      })
  }

  handleUpdateItemDetails = (e, itemId) => {
    this.props.history.push(`/portal/app/admin/course/entity/update/${itemId}`)
  }

  render() {
    let purchaseEntityComponent, purchaseItemTypeComponent, displayComponent
    let handleUpdateItemDetails = this.handleUpdateItemDetails
    let handleFetchCons = this.handleFetchCons
    purchaseEntityComponent = (
      <Select 
        onChange={this.handlePurchaseEntity} 
        value={this.state.data.purchaseEntityCriteria}
      >
      {this.state.data.purchaseEntity.map((entity) =>(
         <option key ={entity.id} value={entity.id}>{entity.name}</option>
        ))}
      </Select>
    )

    purchaseItemTypeComponent = (
      <Select 
          onChange={this.handlePurchaseItemType} 
          value={this.state.data.purchaseItemCriteria}
      >
      {this.state.data.purchaseItemType.map((item) =>(
         <option key={item.id} value={item.id}>{item.name}</option>
      ))}
      </Select>
    )
    displayComponent = (<tbody>
        {this.state.data.purchaseItem.map(function (item) {
          let updateButtonComponent, activeComponent;
          updateButtonComponent = (<td>
            <Button onClick={((e) => handleUpdateItemDetails(e, item.id))}>Update</Button>
            </td>)
          if(item.active === true) {
            activeComponent = (<td>Yes</td>)
          }
          else {
            activeComponent = (<td>No</td>)
          }
          return (<tr key={item.id}>
            <td>{item.id}</td>
            <td>{item.name}</td>
            <td>{item.description}</td>
            <td>{item.currency}</td>
            <td>{item.amount}</td>
            <td><a href = {item.img_link}>{item.img_link}</a></td>
            {activeComponent}
            <td>{item.revenue_share}</td>
            <td>{item.start_date}</td>
            <td>{item.end_date}</td>
            <td>{item.duration}</td>
            {updateButtonComponent}
          </tr>)
          })}
      </tbody>)
    let paginationKey = this.state.totalCount
    let handleSearchQuery = this.handleSearchQuery
    return(
      <div>
        <Grid>
          <GridCell span="4" fullWidth>{purchaseEntityComponent}</GridCell>
          <GridCell span="4" fullWidth>{purchaseItemTypeComponent}</GridCell>
          <GridCell span="4"><Button className="add-opportunity" onClick={() => handleSearchQuery(1)}>Search</Button></GridCell>
          <GridCell span="12">
            <table>
              <thead>
                <th>ID</th>
                <th>Name</th>
                <th>Description</th>
                <th>Currency</th>
                <th>Amount</th>
                <th>Image Link</th>
                <th>Active</th>
                <th>Revenue Share(%)</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Duration</th>
                <th>Update</th>
              </thead>
              {displayComponent}
            </table>
          </GridCell>
        </Grid>
        <div key={paginationKey}>
          <PaginationComponent totalItems = {this.state.totalCount}
            itemsPerPage = {this.state.itemsPerPage} 
            onHandleItemsFetch = {handleFetchCons} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminViewCourseEntities);


// WEBPACK FOOTER //
// ./src/views/admin/AdminViewCourseEntities.jsx